import React, { useState } from 'react';
import './face-id.styles.scss';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import dec_identity from '../../../assest/Home/circular_icons/dec_identity.png';
import passwordless from '../../../assest/Home/circular_icons/passwordless.png';
import zero_proof from '../../../assest/Home/circular_icons/zero_proof.png';
import biometrics from '../../../assest/Home/circular_icons/biometrics.png';
import verifiable from '../../../assest/Home/circular_icons/verifiable.png';
import wallets from '../../../assest/Home/circular_icons/wallets.png';
import decentralization from '../../../assest/Home/circular_icons/decentralization.png';
import security from '../../../assest/Home/circular_icons/security.png';
import digitalization from '../../../assest/Home/circular_icons/digitalization.png';

export const FaceId = () => {
  const { t } = useTranslation();
  const [content, togglecontent] = useState(0);

  const btns = [
    { name: 'btn-1', link: '/solution/identity-verification', image: dec_identity },
    { name: 'btn-2', link: '/solution/passwordless', image: passwordless },
    { name: 'btn-3', link: '/solution/age-verification', image: zero_proof },
    { name: 'btn-4', link: '/solution/data-tokenization', image: biometrics },
    { name: 'btn-5', link: '/solution/digital-credentials', image: verifiable },
    { name: 'btn-6', link: '/solution/id-wallet', image: wallets },
    { name: 'btn-7', image: decentralization },
    { name: 'btn-8', image: security },
    { name: 'btn-9', image: digitalization },
  ];

  const card = t(`faceId.cards.${content}`, { returnObjects: true });

  return (
    <div className='faceId-content'>
      <div className='faceId-content_text'>
        <p className='faceId-content_text-2'>{t('faceId.heading')}</p>
        <p className='faceId-content_text-3'>{t('faceId.description')}</p>
      </div>

      <div className='faceId-content_dynamic'>
        <div className='faceId-content_dynamic-1'>
          <div className='faceId-content-text-block'>
            <p className='faceId-content_dynamic-1-title'>{card.title}</p>
            <p className='faceId-content_dynamic-1-desc'>{card.content}</p>
            {btns[content].link && (
              <Link
                to={btns[content].link}
                className='read-more-link'
                onClick={() => window.scrollTo(0, 0)}
              >
                {t('faceId.readMore')}
              </Link>
            )}
          </div>
        </div>

        <div className='faceId-dyanmic-img-div'>
          <img src={btns[content].image} className='faceId-content_dynamic-2-img' alt='feature' />
          {btns.map((_, index) => (
            <button
              key={index}
              className={`dynamic-btn dynamic-btn_${index + 1}`}
              value={index}
              onMouseOver={(e) => togglecontent(e.target.value)}
            >
              btn-{index + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
